// extracted by mini-css-extract-plugin
export default {"container":"Gn-z","brandName":"Hn-z","productName":"In-z","aboveGalleryInfo":"Jn-z","belowGalleryInfo":"Kn-z","breakLongProductName":"Ln-z"};